import { useFlowFilter } from '../FlowFilterContext'
import { useDateRangeCtx } from '../DateRangeContext'
import { DateRangeTabs } from '../DateRangeTabs'
import { AcquisitionTable } from '../widgets/AcquisitionTable'
import { DayHourHeatmap } from '../widgets/DayHourHeatmap'
import { acquisitionCsvUrl } from '../../lib/api'

export function AcquisitionSection() {
  const { range } = useDateRangeCtx()
  const { variantParam, audienceParam } = useFlowFilter()
  return (
    <>
      <div className="section-toolbar">
        <DateRangeTabs />
        <span style={{ flex: 1 }} />
        <a href={acquisitionCsvUrl(range, variantParam, audienceParam)} download className="csv-export">Eksportér CSV</a>
      </div>
      <AcquisitionTable range={range} />
      <DayHourHeatmap range={range} />
    </>
  )
}
